import React, { PureComponent } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import PropTypes from 'prop-types'

import * as StoresActions from '../../actions/content'
import { Playlists as PlaylistsDOM } from '../../components/Screens/Content'

class Playlists extends PureComponent {
    static propTypes = {
        data: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
        fetchPlaylists: PropTypes.func.isRequired,
    }

    constructor(props) {
        super(props)

        this.state = {
            search: '',
        }

        this.onChangeInput = this.onChangeInput.bind(this)
    }

    componentDidMount() {
        const { fetchPlaylists } = this.props
        fetchPlaylists()
    }

    // On Change any input value
    onChangeInput({ target: { name, value } }) {
        this.setState({ [name]: value }, this.search)
    }

    render() {
        const { data } = this.props
        const { search } = this.state
        return <PlaylistsDOM data={data} onChangeSearch={this.onChangeInput} valueSearch={search} />
    }
}

const mapStateToProps = ({ content: { playlists: data } }) => ({
    data,
})

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            ...StoresActions,
        },
        dispatch
    )

export default connect(mapStateToProps, mapDispatchToProps)(Playlists)
